"use client";
import { jsx as a } from "react/jsx-runtime";
import d from "clsx";
import { memo as o } from "react";
import { Box as r } from "../base/Base.js";
import '../../assets/Table.css';const c = "_table_10npy_1", n = "_head_10npy_8", l = "_head__item_10npy_11", p = "_body__item_10npy_29", y = "_success_10npy_46", b = "_progress_10npy_49", i = "_error_10npy_52", u = "_body_10npy_29", s = {
  table: c,
  head: n,
  head__item: l,
  body__item: p,
  success: y,
  progress: b,
  error: i,
  body: u
}, h = o(({ children: e }) => /* @__PURE__ */ a(r, { gap: 0, className: s.table, children: e }));
h.displayName = "Table";
const N = o(({ children: e }) => /* @__PURE__ */ a(r, { row: !0, className: s.head, children: e }));
N.displayName = "TableHead";
const T = o(({ text: e }) => /* @__PURE__ */ a(r, { gap: 0, row: !0, className: s.head__item, children: e }));
T.displayName = "TableHeadItem";
const g = o(({ children: e }) => /* @__PURE__ */ a(r, { gap: 0, row: !0, className: s.body, children: e }));
g.displayName = "TableBody";
const B = o(
  ({ text: e, success: t, error: _, progress: m }) => /* @__PURE__ */ a(
    r,
    {
      gap: 0,
      row: !0,
      className: d(s.body__item, {
        [s.success]: t,
        [s.error]: _,
        [s.progress]: m
      }),
      children: e
    }
  )
);
B.displayName = "TableBodyItem";
export {
  h as Table,
  g as TableBody,
  B as TableBodyItem,
  N as TableHead,
  T as TableHeadItem
};
